import { useState, useMemo } from 'react'
import { Link } from 'react-router-dom'
import { greekToLatin, matchesLine, type LineInfo } from '@/lib/api'
import { useLines } from '@/lib/queries'

type Language = 'el' | 'en'

interface LinesListProps {
  lang: Language
  translations: {
    searchPlaceholder: string
    favorites: string
    allLines: string
    loading: string
  }
}

export function LinesList({
  lang,
  translations: t
}: LinesListProps) {
  const [searchQuery, setSearchQuery] = useState('')
  const { data: lines, isLoading } = useLines()

  const getLineDescription = (line: LineInfo) =>
    lang === 'en' ? (line.LineDescrEng || line.LineDescr) : line.LineDescr

  const filteredLines = useMemo(() =>
    (lines || []).filter(l => matchesLine(l, searchQuery)),
    [lines, searchQuery]
  )

  if (isLoading) {
    return <div className="loading">{t.loading}</div>
  }

  return (
    <div className="lines-view">
      <input
        type="text"
        className="search-input"
        placeholder={t.searchPlaceholder}
        value={searchQuery}
        onChange={e => setSearchQuery(e.target.value)}
      />
      <h3>{t.allLines}</h3>
      <div className="lines-grid">
        {filteredLines.map(line => (
          <Link
            key={line.LineCode}
            className="line-card"
            to={`/${greekToLatin(line.LineID).toLowerCase()}`}
          >
            <div className="line-id">{line.LineID}</div>
            <div className="line-desc">{getLineDescription(line)}</div>
          </Link>
        ))}
      </div>
    </div>
  )
}
